import React, { useMemo } from 'react';
import { isMobile, parseNumberByPrecision, RoundStatus } from '@pascal/pascal-core';
import { parseOddByPrecision } from '../../../helpers';
import { TranslationKeys } from '../../../enums/translationKeys';
import { FISH_IMAGES } from '../../../core/constants/fishImagesArray';

export const GameSpecificCheckHashPopupTopSection = ({ currentData, t }) => {
  const { roundData, additionalParams, odd, status } = currentData || {};
  const emptyOrResultsArr = useMemo(() => {
    const roundDataLength = roundData?.length;

    if (roundData && (status === RoundStatus.Finished || additionalParams)) {
      if (roundDataLength >= 10) {
        return roundData;
      }
      return [...roundData, ...new Array(10 - roundDataLength).fill(null)];
    }

    return new Array(10).fill(null);
  }, [roundData]);

  const roundTotalOdd = useMemo(() => {
    const totalOdd = +roundData?.[0].odd
      ? roundData
          ?.filter((item) => item.odd)
          .reduce((acm, current) => parseNumberByPrecision(acm, current.odd, 2, true), 1)
      : 0;
    return parseOddByPrecision(totalOdd, 2);
  }, [roundData]);

  return (
    <>
      <h3 className='fs-total-add'>
        {t(odd || odd === 0 ? TranslationKeys.Odd : TranslationKeys.TOTAL_ODD)}:
        <span>
          x
          {odd || odd === 0 ? (
            odd
          ) : roundData ? (
            roundTotalOdd
          ) : (
            <span className='fs-total-add_span'>--</span>
          )}
        </span>
      </h3>
      <div className='fs-gathered-fish-list-wrapper'>
        <div className='scrollable-container'>
          <ul className='fs-gathered-fish-list'>
            {emptyOrResultsArr.map((roundResult, index) => {
              return (
                <li
                  className={`fs-gathered-fish-list-el ${
                    additionalParams
                      ? additionalParams.betStep <= index && additionalParams.cashOutStep > index
                        ? 'active'
                        : ''
                      : 'active'
                  }`}
                  data-odd={roundResult?.odd}
                  key={index}
                >
                  <div className={`fs-gathered-fish-image-wrapper ${roundResult ? 'counter' : ''}`}>
                    {(roundResult?.resultType || roundResult?.resultType === 0) && (
                      <img
                        className='fs-gathered-fish-image'
                        src={FISH_IMAGES[roundResult?.resultType]}
                        alt=''
                      />
                    )}
                  </div>
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    </>
  );
};

export const AboutHashInnerContent = ({ t, withPadding, scrollRef }) => {
  return (
    <div className={`pr-f-text-wrp ${withPadding ? 'p-t-hash' : ''}`} ref={scrollRef}>
      {isMobile() && (
        <p className='pr-f-text with-margin_top'>{t(TranslationKeys.PROVABLY_FAIRNESS)}</p>
      )}
      <p className='pr-f-text'>{t(TranslationKeys.FAIRNESS_P1)}</p>
      <p className='pr-f-text w-b-ba'>
        56256939E58A146CBBF6FD3B2583D5026EE2D2D5B41B54D70D0C5E929C9A4CF65CB0434240F9D2BC84F7159648853EE8293EF28A8B926BDBD64BCFF199044949:
      </p>
      <p className='pr-f-text'>{t(TranslationKeys.FAIRNESS_P2)}</p>
      <p className='pr-f-text'>{t(TranslationKeys.FAIRNESS_P3)}</p>
      <p className='pr-f-text'>{t(TranslationKeys.FAIRNESS_P4)}</p>

      <ol className='pr-f-text'>
        <li className='pr-f-text'>{t(TranslationKeys.FAIRNESS_P5)}</li>
        <li className='pr-f-text'>{t(TranslationKeys.FAIRNESS_P6)}</li>
        <li className='pr-f-text'>{t(TranslationKeys.FAIRNESS_P7)}</li>
        <li className='pr-f-text'>{t(TranslationKeys.FAIRNESS_P8)}</li>
      </ol>
      <p className='pr-f-text'>{t(TranslationKeys.FAIRNESS_P9)}</p>
      <p className='pr-f-text'>{t(TranslationKeys.FAIRNESS_P10)}</p>
      <p className='pr-f-text'>258658_5,1.2,4.8,1,2_Fishing_386ed997-a025-44cc-9d82-bac3a62e221d</p>
      <p className='pr-f-text'>{t(TranslationKeys.FAIRNESS_P11)}</p>
      <p className='pr-f-text w-b-ba'>
        56256939E58A146CBBF6FD3B2583D5026EE2D2D5B41B54D70D0C5E929C9A4CF65CB0434240F9D2BC84F7159648853EE8293EF28A8B926BDBD64BCFF199044949
      </p>
      <p className='pr-f-text'>{t(TranslationKeys.FAIRNESS_P12)}</p>
    </div>
  );
};
